import type {
	ContainerList,
	ContainerData,
	GetContainersDataPlugin,
} from '@atlassiansox/cross-flow-plugins/types';
import { ContainerTypes } from '@atlassiansox/cross-flow-plugins/types';
import { createGetContainersPlugin } from '@atlassiansox/cross-flow-plugins/main';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import {
	SiteInformationQuery,
	type SiteInformationQuery$data,
} from '@confluence/session-data/entry-points/SiteInformationQuery.graphql.ts';

interface SiteSettings {
	siteSettings: {
		siteTitle: string;
	};
	tenant: {
		cloudId: string;
	};
}

function hasSiteSettings(data: unknown): data is SiteSettings {
	return data && typeof data === 'object' && data['siteSettings'] && data['tenant'];
}

const getCloudId = async (): Promise<ContainerList> => {
	const { data } = await queryInterop<SiteInformationQuery$data>({
		query: SiteInformationQuery,
	});

	const containers: ContainerData[] = [];
	if (hasSiteSettings(data)) {
		const { siteTitle } = data.siteSettings;
		const tenantId = data.tenant.cloudId;

		containers.push({
			id: tenantId,
			displayName: siteTitle,
			type: ContainerTypes.ATLASSIAN_CLOUD_ID,
		});
	}

	return {
		type: ContainerTypes.ATLASSIAN_CLOUD_ID,
		containers,
	};
};

export const getContainersPlugin: GetContainersDataPlugin = createGetContainersPlugin(getCloudId);
